import {
  AssignmentChangeStatus,
  AssignmentStatus,
  GeneralStatus,
  GeolocationPermissionStatus,
  StatusMap
} from './types';

export const GENERAL_STATUS_MAP: Record<GeneralStatus, StatusMap> = {
  [GeneralStatus.OPEN]: { color: 'info', label: 'week.status.current' },
  [GeneralStatus.REPORTED]: { color: 'info', label: '' },
  [GeneralStatus.IN_REVIEW]: {
    color: 'warning',
    label: 'week.status.inReview'
  },
  [GeneralStatus.CORRECTED]: {
    color: 'primary',
    label: 'week.status.corrected'
  },
  [GeneralStatus.CONFIRMED]: {
    color: 'success',
    label: 'week.status.confirmed'
  },
  [GeneralStatus.CLOSED]: { color: 'success', label: '' }
};

export const ASSIGNMENT_STATUS_MAP: Record<AssignmentStatus, StatusMap> = {
  [AssignmentStatus.UPCOMING]: {
    color: 'primary',
    label: 'assignment.status.upcoming'
  },
  [AssignmentStatus.ACTIVE]: {
    color: 'info',
    label: 'assignment.status.active'
  },
  [AssignmentStatus.COMPLETED]: {
    color: 'neutral',
    label: 'assignment.status.completed'
  }
};

export const ASSIGNMENT_CHANGE_STATUS_MAP: Record<
  AssignmentChangeStatus,
  StatusMap
> = {
  [AssignmentChangeStatus.APPLIED]: {
    color: 'success',
    label: 'assignmentChange.status.applied'
  },
  [AssignmentChangeStatus.NOT_APPLIED]: {
    color: 'warning',
    label: 'assignmentChange.status.pending'
  }
};

export const GEOLOCATION_STATUS_MAP: Record<
  GeolocationPermissionStatus,
  StatusMap
> = {
  [GeolocationPermissionStatus.GRANTED]: {
    color: 'success',
    label: 'geolocationSettingsPage.status.granted'
  },
  [GeolocationPermissionStatus.DENIED]: {
    color: 'error',
    label: 'geolocationSettingsPage.status.denied'
  },
  [GeolocationPermissionStatus.PROMPT]: {
    color: 'warning',
    label: 'geolocationSettingsPage.status.prompt'
  },
  [GeolocationPermissionStatus.UNAVAILABLE]: {
    color: 'neutral',
    label: 'geolocationSettingsPage.status.unavailable'
  }
};
